export default __webpack_public_path__ + "static/media/Annabelle 9781408331439.9c101d4a.jpg";